import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import moment from 'moment'
import datePicker from '../../component/dccore-form/datePicker.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import multimedia from '../../component/dccore-form/multimedia.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import Ckeditor from '../../component/dccore-form/ckeditor.vue'

if ($('#package_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#package_form',
    components: {
      RingLoader,
      datePicker,
      moment,
      TextInput,
      NumberInput,
      Checkbox,
      multimedia,
      Singleselect,
      Ckeditor
    },
    mixins: [mixins],
    data: {
      loading: 0,
      form: {
        entity: {
          active: true,
          role: 'PACKAGE',
          defaultVariant: null,
        },
        options: {
          errors: {},
          brands: [],
          createdAt: new moment(),
          role: [
            {
              id: 'PACKAGE',
              name: Translator.trans('package.entity.roles.package'),
            },
          ],
          defaultVariant: [],
        }
      },
      entityId: null,
      multimedia: [],
    },
    watch:{
    },
    computed(){
    },
    mounted() {
      this.loading++
      this.getBrands()
      this.getPackageRoles()

      if ($('#entity_id').length) {
        this.entityId = $('#entity_id').val()
        this.getVariants()
        this.getPackage()
      }

      this.loading--
    },
    methods: {
      createPackage(redirect) {
        let url = Routing.generate('api_post_package')

        let data = {
          data: this.form.entity,
          multimedia: this.multimedia,
        }

        delete data.data.createdAt

        this.loading++
        this.$http.post(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('package_grid'))
          } else {
            toastr.success(Translator.trans('form.created'))
            this.form.options.errors = {}
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      updatePackage(redirect) {
        this.loading++
        let url = Routing.generate('api_patch_package', {
          id: this.entityId,
        })
        let data = {
          data: this.form.entity,
          multimedia: this.multimedia,
        }
        delete data.data.createdAt

        this.$http.patch(url, data).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('package_grid'))
          } else {
            toastr.success(Translator.trans('form.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      getPackage() {
        this.loading++
        let url = Routing.generate('api_get_package', { id: this.entityId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          this.form.entity = response.data
          if (this.form.entity.multimedia) {
            this.multimedia = this.form.entity.multimedia.collection
            delete this.form.entity.multimedia
          }

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands() {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getPackageRoles() {
        this.loading++
        let url = Routing.generate('api_get_package_roles')
        this.$http.get(url).then(response => {
          this.form.options.role = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getVariants() {
        this.loading++
        let url = Routing.generate('api_get_variants_for_package', {
          package: this.entityId,
          context: 'list'
        })
        this.$http.get(url).then(response => {
          this.form.options.defaultVariant = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    }
  })

}
